/**
 * Base types for the events generated from `Shared/Analytics/mixpanel_structure.yaml` by
 * `generate_mixpanel_structure.py` into `generatedEvents.ts`. This file is fixed, hand-maintained
 * code; only the event factories are generated.
 *
 * Keys and values are the registry's wire form, shared verbatim with Android and iOS, so the web app
 * sends a generated event through `fireGeneratedAnalyticsEvent`, never `fireAnalyticsEvent`.
 */

export type GeneratedAnalyticsPropertyValue =
  | string
  | number
  | boolean
  | string[]
  | number[]
  | boolean[]
  | GeneratedAnalyticsProperties

/** A registry bundle used as a property's type nests its own map under the key. */
export type GeneratedAnalyticsProperties = {[key: string]: GeneratedAnalyticsPropertyValue}

export type GeneratedAnalyticsEvent<Name extends string = string> = {
  name: Name
  properties: GeneratedAnalyticsProperties
}

/**
 * The wire encoding of a registry `date` property. Mixpanel date-types a string only when it carries
 * a timezone designator, so the `Z` is load-bearing; Android's `Date.analyticsValue` sends the
 * identical string, and iOS the same instant with fractional seconds added.
 */
export function analyticsDateValue(date: Date): string {
  return date.toISOString().replace(/\.\d{3}Z$/, 'Z')
}
